// domain table

import { SearchIcon } from "lucide-react";
import SelectBox from "../components/v2/SelectBox";
import Typography from "../components/v2/Typography";
import { useCallback, useEffect, useState } from "react";
import Button from "../components/v2/Button";
import ServicesHeader from "../atoms/ServicesHeader";
import { DomainValuationToolAdvert } from "./WHOISTools";
import { WHOISDomainToolAdvert } from "./AppraisalTool";
import BlogSection from "../atoms/BlogPreview";

// const Featured = () => {

//     const [search, setSearch] = useState("");

//     const handleSearch = (e) => {
//         setSearch(e.target.value);
//     }

//     const [sort, setSort] = useState("price");
//     const [category, setCategory] = useState("all");
//     const [tld, setTld] = useState("com");

//     const handleSort = (e) => {
//         setSort(e.target.value);
//     }

//     const handleCategory = (e) => {
//         setCategory(e.target.value);
//     }

//     const handleTld = (e) => {
//         setTld(e.target.value);
//     }

//     return (
//         <>
//             <section className="services-hero-wrapper">
//                 <div className="inner">
//                     <div className="hero-heading">
//                         <Typography variant="h1">Featured Domains for sale</Typography>
//                     </div>
//                 </div>
//             </section>
//             <section className="featured-listing">
//                 <div className="inner">

//                     <div className="search-toolbar">
//                         <div className="inner">
//                             <div className="searchbar-input">
//                                 <div className="search-input-box">
//                                     <div className="search-input-icon">
//                                         <SearchIcon width={18} />
//                                     </div>
//                                     <div className="search-input-field">
//                                         <input placeholder="Find your Domain" type="text" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="search-tools">
//                                 <span className="search-tool">
//                                     <SelectBox onSelect={(opt) => {
//                                         handleCategory(opt.value);
//                                     }} label="Category" options={[{
//                                         label: "All",
//                                         value: "all"
//                                     },
//                                     {
//                                         label: "No one",
//                                         value: "no-one"
//                                     }]} />
//                                 </span>
//                                 <span className="search-tool">
//                                     <SelectBox label="TLD" options={[{
//                                         label: "COM",
//                                         value: "com"
//                                     },
//                                     {
//                                         label: "NET",
//                                         value: "net"
//                                     }]} />
//                                 </span>
//                                 <span className="search-tool">
//                                     <SelectBox label="Sort by" options={[{
//                                         label: "Price",
//                                         value: "price"
//                                     },
//                                     {
//                                         label: "Domain age",
//                                         value: "age"
//                                     }]} />
//                                 </span>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </section>
//         </>
//     );
// };


const Featured = () => {
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState("price");
    const [category, setCategory] = useState("all");
    const [tld, setTld] = useState("com");
    const [limit, setLimit] = useState(20);
    
    const handleSearch = (e) => setSearch(e.target.value);
    const handleSort = (e) => setSort(e.target.value);
    const handleCategory = (value) => setCategory(value);
    const handleTld = (value) => setTld(value);
  
    // const data = [
    //   { name: "canadashopping.com", category: "Ecommerce", tld: "com", value: 800 },
    //   { name: "indiatravel.net", category: "Travel", tld: "net", value: 600 },
    //   { name: "myhealthcare.com", category: "Health", tld: "com", value: 1000 },
    //   { name: "justsports.net", category: "Sports", tld: "net", value: 500 },
    // ];
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [categoryList, setCategoryList] = useState([]);
    const [tldList, setTldList] = useState([]);

    const fetchFeaturedData = useCallback(async () => {
      try {
        const resp = await fetch(`https://api.webstadia.com/v1/dt/b88e4e75-3bda-4606-80e6-1c5690e63376`);
        const data = await resp.json();
        console.log(data);
        setData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }, []);

    useEffect(() => {
      setLoading(true);
      fetchFeaturedData();
    }, []);

    useEffect(() => {
      const categories = [...new Set(data.map((d) => d.category))];
      const tlds = [...new Set(data.map((d) => d.tld))];
      setCategoryList(categories);
      setTldList(tlds);
    }, [data]);
    
  
    const filtered = data
      .filter((d) =>
        d.name.toLowerCase().includes(search.toLowerCase()) &&
        (category === "all" || d.category.toLowerCase() === category) &&
        (tld === "all" || d.tld.toLowerCase() === tld)
      )
      .sort((a, b) => {
        if (sort === "price") return b.value - a.value;
        if (sort === "age") return a.name.localeCompare(b.name); // Replace with real age logic
        return 0;
      });
  
    return (
      <>
        <section className="services-hero-wrapper" style={{
            paddingBottom: 0
        }}>
          <div className="inner">
            <div className="hero-heading">
              <Typography variant="h1">Featured Domains for sale</Typography>
            </div>
          </div>
        </section>
  
        <section className="featured-listing">
          <div className="inner">
            <div className="search-toolbar">
              <div className="inner">
                <div className="searchbar-input">
                  <div className="search-input-box">
                    <div className="search-input-icon">
                      <SearchIcon width={18} />
                    </div>
                    <div className="search-input-field">
                      <input
                        placeholder="Find your Domain"
                        type="text"
                        value={search}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                </div>
                <div className="search-tools">
                  <span className="search-tool category-select">
                    <SelectBox
                      label="Category"
                      onSelect={(opt) => handleCategory(opt.value)}
                      options={[
                        { label: "All", value: "all" },
                        ...categoryList.map((c) => ({ label: c, value: c.toLowerCase() })),
                      ]}
                    />
                  </span>
                  <span className="search-tool">
                    <SelectBox
                      label="TLD"
                      onSelect={(opt) => handleTld(opt.value)}
                      options={[
                        { label: "All", value: "all" },
                        ...tldList.map((t) => ({ label: t.toUpperCase(), value: t })),
                      ]}
                    />
                  </span>
                  {/* <span className="search-tool">
                    <SelectBox
                      label="Sort by"
                      onSelect={(opt) => handleSort(opt.value)}
                      options={[
                        { label: "Price", value: "price" },
                        // { label: "Domain age", value: "age" },
                      ]}
                    />
                  </span> */}
                </div>
              </div>
            </div>
  
            <div className="domain-table">
              <div className="header">
                <div>Name</div>
                <div>Category</div>
                <div>TLD</div>
                <div>Est Value</div>
              </div>
  
              {filtered.slice(0, limit).map((row, i) => (
                <div className="row" key={i}>
                  <div className="name">
                    {row.name}
                  </div>
                  <div>{row.category}</div>
                  <div>{row.tld}</div>
                  <div>{row.value}</div>
                </div>
              ))}

              {limit < filtered.length && <div className="footer">
                <Button variant="secondary" onClick={() => setLimit(limit + 20)}>Load more</Button>
              </div>}
            </div>

            <BlogSection display={'onlyNewsletter'} />

          </div>
        </section>
        
        <DomainValuationToolAdvert />
        {/* <WHOISDomainToolAdvert /> */}
        <ServicesHeader />

      </>
    );
  };

export default Featured;